<template>
  <div class="lic-container">
    <div
      :class="numberClass"
      :style="numberStyle"
      class="lic-number-block me-space-xs me-md-space-sm text-center fs-large fw-bold">
      {{ number }}
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  number: string;
  numberVariant?: string;
  numberBgColor?: string;
}

const props = withDefaults(defineProps<Props>(), {
  numberVariant: "dark-3",
  numberBgColor: "var( --rds-secondary, #ffc627)",
});

const numberStyle = computed(() => {
  return { "background-color": props.numberBgColor };
});

const numberClass = computed(() => {
  return `text-${props.numberVariant}`;
});
</script>

<style lang="scss" scoped>
.lic-container {
  display: flex;
  flex-flow: row;
  align-items: top;
}
.lic-number-block {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  flex: none;
  line-height: 2em;
}
</style>
